module.exports = __webpack_public_path__ + "static/raam-25a2698a21587e1c81eff48c4f9cae7f.jpg";